import * as mutationTypes from "../store/mutation-types";
import ShopSelectionMixin from "./ShopSelection.mixin";
import {generateExpression} from "../domains2/helpers/targetGroups";
import LoggerProvider from "../providers/LoggerProvider";

export default {
	data() {
		return {};
	},
	mixins: [ShopSelectionMixin],
	methods: {
		async detectedSecretShop() {
			const secretShopId = this.$route.query.secretShopId;

			if (secretShopId) {
				const shops = await this.$store.dispatch(
					mutationTypes.FETCH_AND_CACHE_SHOPS,
					{
						cacheShops: false,
						showSecretRestaurants: true
					}
				);

				const secretShop = shops.find((shop) => {
					const shopOptions = shop.shopOptions || {};
					return (
						shop.id === secretShopId && shopOptions.isSecretRestaurant === true
					);
				});

				if (secretShop) {
					await this.$store.commit(
						mutationTypes.SET_GLOBAL_SELECTED_SHOP,
						this.baseRemapShopData(secretShop)
					);
					return true;
				}
			}

			return false;
		},
		getCustomMarketingCard(customPageCriteria) {
			if(!customPageCriteria) {
				return;
			}
			this.$store.dispatch(mutationTypes.GATHER_EVALUATION_TAG_DATA, { page: customPageCriteria.toLowerCase() });
			const evaluationData = this.$store.getters.customerEvaluationData;
			const targetGroups = this.$store.getters.targetGroupData || [];
			const isTargetGroupEnabledInShop = (options) => {
				const allowedShops = options && options.shops;
				if(allowedShops && allowedShops.length && this.$store.getters.globalSelectedShop) {
					return allowedShops.includes(this.$store.getters.globalSelectedShop.id);
				}
				return true;
			};
			const mapTargetGroupApplicable = (targetGroups) => targetGroups
				.filter(({options}) => {
					return isTargetGroupEnabledInShop(options);
				})
				.filter((targetGroup) => targetGroup.expressions
					.some((expression) => {
						try {
							return generateExpression(evaluationData, expression);
						} catch (error) {
							LoggerProvider.logEvent({
								message: `|TARGETING GROUPS| *Frontend*: Expression validation failed`,
								eventName: "TargetingGroupExpressionFailed",
								eventCategory: "TargetingGroups",
								eventDomain: "TargetingGroups",
								data: {
									message: error.message,
									name: error.name
								}
							});
							return false;
						}
					})
				);
			const results = mapTargetGroupApplicable(targetGroups)
				.sort((a, b) => b.priority - a.priority);
			return results.find((tg) => {
				return tg.expressions.some(exp => {
					return exp.includes(customPageCriteria);
				});
			});
		}
	}
};
